import { createStore } from 'satcheljs';

export interface PremiumSupportOptionStore {
    isInTreatmentFlight: boolean;
}

const premiumSupportOptionStore: PremiumSupportOptionStore = {
    isInTreatmentFlight: false,
};

const store = createStore<PremiumSupportOptionStore>(
    'PremiumSupportOptionStore',
    premiumSupportOptionStore
)();
export default store;
